<template>
  <div>
    <OverseasColumnSections />
    <SiteFooter :key="`footer-${pageKey}`" />
  </div>
</template>

<script>
import OverseasColumnSections from '@/components/layout/overseasColumn/OverseasColumnSections'
import SiteFooter from '@/components/layout/newHome/sections/SiteFooter.vue'

export default {
  name: 'OverseasColumn',
  components: {
    OverseasColumnSections,
    SiteFooter
  },
  computed: {
    pageKey() {
      const locale = (this.$i18n && this.$i18n.locale) || 'zh-CN'
      const routeLang = (this.$route && this.$route.query && this.$route.query.lang) || ''
      return `${locale}-${routeLang}`
    }
  }
}
</script>
